import { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import { transformFiltersV2 } from 'utils/helperMethods';

interface FilterKey {
    label: string;
    value: string;
    dimension: string;
}

interface FilterStateResult {
    allCheckedAttribute: any;
    allSelectedValueForAllAttribute: any;
    applyFilterObject: any;
    selectedFilter: any;
    setSelectedFilter: (filter: any) => void;
    tempApplyFilterObject: any;
    setTempApplyFilterObject: (obj: any) => void;
    currentFilters: any;
    reset: () => void;
    onSave: (resultObj: any) => void;
}

function useFilterState(filterKeys: FilterKey[]): FilterStateResult {
    const [allCheckedAttribute, setAllCheckedAttribute] = useState<any>({});
    const [allSelectedValueForAllAttribute, setAllSelectedValueForAllAttribute] = useState<any>({});
    const [applyFilterObject, setApplyFilterObject] = useState<any>({});
    const [selectedFilter, setSelectedFilter] = useState<any>(null);
    const [tempApplyFilterObject, setTempApplyFilterObject] = useState<any>({});

    const currentFilters = useMemo(
        () => (filterKeys.length > 0 ? transformFiltersV2(applyFilterObject, filterKeys) : {}),
        [applyFilterObject, filterKeys],
    );

    const reset = useCallback(() => {
        const checked: any = {};
        const selectAll: any = {};
        const applyObj: any = {};
        filterKeys.forEach((k) => {
            checked[k.value] = new Set();
            selectAll[k.value] = false;
            applyObj[k.value] = {};
        });
        setAllCheckedAttribute(checked);
        setAllSelectedValueForAllAttribute(selectAll);
        setApplyFilterObject(_.cloneDeep(applyObj));
        setSelectedFilter(null);
        setTempApplyFilterObject({});
    }, [filterKeys]);

    const onSave = useCallback((resultObj: any) => {
        setAllCheckedAttribute(resultObj.allCheckedAttribute);
        setAllSelectedValueForAllAttribute(resultObj.allSelectedValueForAllAttribute);
        setApplyFilterObject(resultObj.applyFilterObject);
    }, []);

    return {
        allCheckedAttribute,
        allSelectedValueForAllAttribute,
        applyFilterObject,
        selectedFilter,
        setSelectedFilter,
        tempApplyFilterObject,
        setTempApplyFilterObject,
        currentFilters,
        reset,
        onSave,
    };
}

export default useFilterState;
